export default __webpack_public_path__ + "8c83788b1b887c58de4941af2703ad86.svg";